import React, { useEffect, useState } from 'react';
import './MarqueeBanner.css';
import api from '../api';

const MarqueeBanner: React.FC = () => {
    const [text, setText] = useState<string>('');
    const [enabled, setEnabled] = useState<boolean>(false);

    useEffect(() => {
        const fetchMarquee = async () => {
            try {
                // Ensure to avoid caching on initialization
                const res = await api.get('/site-settings?t=' + Date.now());
                if (res.data?.data) {
                    setText(res.data.data.marqueeText || '');
                    setEnabled(res.data.data.marqueeEnabled ?? true);
                }
            } catch (error) {
                // Fail gracefully silently
            }
        };
        fetchMarquee();
    }, []);

    if (!enabled || !text.trim()) {
        return null;
    }

    return (
        <div className="marquee-container">
            <div className="marquee-content">
                <span>{text}</span>
            </div>
        </div>
    );
};

export default MarqueeBanner;
